export const callWithDelay = <T extends unknown[], R>(fn: (...args: T) => R, delay: number) => {
  return (...args: T): Promise<R> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const result = fn(...args);
        resolve(result);
      }, delay);
    });
  };
};
